import { http } from '../core';
export default abstract class PagedService {
  async next(url: string | undefined) {
    return await http.loadNext(url);
  }
}
